import { exhangeShopApi } from '../../api/exchangeShop';
const { getGoods, getJszxOverview } = exhangeShopApi;

export default {
  data() {
    return {
      pagination: {
        page: 1,
        total: 0,
        page_size: 8,
      },
      balance: 0,
      activeName: '2',
      dataLoading: false,
      allCount: 0,
      totalList: [],
      firstLoad: true,
      loading: false,
      refreshing: false,
      finished: false,
    };
  },
  created() {
    this.getJszxMoney();
    this.getGoodsList();
    this.Report('view', 'ExchangeMallPage');
  },
  methods: {
    getJszxMoney() {
      getJszxOverview({ dtype: 1 }).then(res => {
        if (res.code === 0) {
          this.balance = res.data.money;
        }
      });
    },
    resetPagination() {
      this.pagination.page = 1;
      this.pagination.total = 0;
    },
    handleTabsChange($panel) {
      console.log('handleTabsChange----', $panel);
      this.activeName = $panel.name;
      this.totalList = [];
      this.finished = false;
      this.resetPagination();
      this.getGoodsList();
    },
    allDataPageChange(page) {
      this.pagination.page = page;
      this.getGoodsList();
      console.log('allDataPageChange---');
    },
    onLoad() {
      if (this.firstLoad) {
        this.firstLoad = false;
      } else {
        this.pagination.page += 1;
        this.getGoodsList(true);
      }
    },
    getGoodsList(isMobile) {
      this.dataLoading = true;
      getGoods({
        page: this.pagination.page,
        page_size: this.pagination.page_size,
        sort_type: this.activeName,
      }).then(res => {
        this.dataLoading = false;
        this.loading = false;
        this.refreshing = false;
        console.log('getGoods----', res);
        if (res.code === 0) {
          const _data = (res.data.list || []).map(item => {
            item.stock = item.stock ? item.stock : 9999;
            return item;
          });
          this.totalList = isMobile ? this.totalList.concat(_data) : _data;
          const totals = parseInt(res.data.total_count, 10);
          this.pagination.total = totals;
          if (this.totalList.length >= totals || !_data.length) {
            this.finished = true;
          }
          if (this.activeName == '1') {
            this.allCount = totals;
          }
        }
      });
    },
    jumpOrderList() {
      this.$router.push({ name: 'ESOrderList' });
    },
    jumpDetail(production) {
      this.Report('click', 'ItemCard', { v3: production.id });
      this.$router.push({
        path: `/exchangeShop/productionDetail/${production.id}`,
        query: { ...production },
      });
    },
    checkRule() {
      console.log('checkRule----');
      window.open('https://dev-wiki.mini1.cn/news/2305', '_blank');
    },
  },
};
